export default "__VITE_ASSET__BL7yymiz__"